// api.config.js
const getApiUrl = () => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  // Для локальной разработки ВСЕГДА используем прокси Vite
  // Это убирает проблемы с CORS при npm run dev
  return '/api';
};

const getWsUrl = () => {
  if (import.meta.env.VITE_WS_URL) {
    if (import.meta.env.VITE_WS_URL.startsWith('/')) {
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${protocol}//${window.location.host}${import.meta.env.VITE_WS_URL}`;
    }
    return import.meta.env.VITE_WS_URL;
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = window.location.host;

  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'ws://localhost:8000/ws';
  }

  return `${protocol}//${host}/ws`;
};

export const API_CONFIG = {
  API_URL: getApiUrl(),
  WS_URL: getWsUrl(),
};

export default API_CONFIG;
